import { create } from 'app/utils/data'

export default {
  namespaced: true,

  state: {
    quote: {
      name: '',
      address1: '',
      address2: '',
      phone: '',
      plan: '',
      numOfSeats: 0,
      price: 0,
      taxRate: 0,
      taxID: '',
      vat: ''
    }
  },

  getters: {
    currentQuote: (state) => state.quote
  },

  mutations: {
    quoteSaved(state, newQuote) {
      state.quote = {
        ...state.quote,
        ...newQuote
      }
    }
  },

  actions: {
    saveQuote({ commit }, quote) {
      commit('quoteSaved', quote)
    },

    async sendQuote({ dispatch }, changes) {
      await create({
        url: '/api/admin/tools/send-quote',
        data: changes
      })
    }
  }
}
